import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zUserLogin = zDocument.extend({
    type: z.literal('userLogin'),
    user: z.string(),
    date: z.string().regex(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)
});
expectType({});
expectType({});
export const EmptyUserLogin = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'userLogin',
    user: '',
    date: ''
};
